<template>
  <div style="height: 100%; width: 100%" dir="rtl">
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_employer"
            :items="employers"
            item-text="name"
            item-value="id"
            label=" أختر المندوب "
            persistent-hint
            return-object
            single-line
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_from"
            v-model="modal_from"
            :return-value.sync="date_from"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_from"
                label="تاريخ من"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_from" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_from = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_from.save(date_from)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-btn color="blue" @click="track_employer">
            جلب بيانات المتابعة</v-btn
          >
        </v-flex>
      </v-layout>
    </v-container>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <l-map style="height: 100%; width: 100%" :zoom="zoom" :center="center">
      <l-control-layers position="topright"></l-control-layers>
      <l-tile-layer :url="url"></l-tile-layer>
      <l-polyline :lat-lngs="polyline.latlngs" :color="polyline.color">
      </l-polyline>
      <l-marker
        v-for="(track, i) in tracks_time"
        :key="tracks_time[i].mytime.date"
        :lat-lng="tracks_time[i].pos"
      >
        <l-popup>{{ tracks_time[i].mytime.date }}</l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { tracks, employers } from "../config/apiRoute.js";

export default {
  data() {
    return {
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 24,
      center: [47.41322, -1.319482],
      markerLatLng: [47.31322, -1.319482],
      polyline: {
        latlngs: [
          [47.334852, -1.509485],
          [47.342596, -1.328731],
          [47.241487, -1.190568],
          [47.234787, -1.358337]
        ],
        color: "red"
      },
      tracks: [],
      tracks_time: [],
      select_employer: { id: "" },
      employers: [],
      loading: false,
      modal_from: false,
      date_from: new Date().toISOString().substr(0, 10)
    };
  },
  mounted() {
    employers().then(response => {
      this.employers = response.data;
      this.loading = false;
    });
  },
  computed: {
    markerLatLngCom() {
      return this.markerLatLng.length > 0
        ? this.markerLatLng
        : [47.41322, -1.0482];
    }
  },
  methods: {
    track_employer() {
      var frmData = new FormData();
      frmData.append("employer_id", this.select_employer.id);
      frmData.append("date_from", this.date_from);
      tracks(frmData).then(res => {
        this.tracks = res.data.all_track_only;
        this.tracks_time = res.data.all_track_time;
        this.polyline.latlngs = this.tracks;
        this.center = this.tracks[0];
        this.markerLatLng = this.tracks[0];
        this.tracks.length > 0 ? "" : alert("لا يوجد بيانات ");
        //   this.circle.center=this.tracks[0];
        //   this.url='http://{s}.tile.osm.org/{z}/{x}/{y}.png';
        //   console.log('polyline',this.polyline.latlngs,'center',this.center,'markerLatLng',this.markerLatLng,'url',this.url)
      });
    }
  }
};
</script>
